import { useAtom } from 'jotai';

import {
  checklistCreationProgressPercentAtom,
  checklistCreationStateAtom,
  schedulesDataGridSelectedRowsAtom,
} from '../state';

export const useSchedulesDataGridStates = () => {
  const [checklistCreationState, setChecklistCreationStateAtom] = useAtom(
    checklistCreationStateAtom
  );
  const [schedulesDataGridSelectedRows, setSchedulesDataGridSelectedRowsAtom] =
    useAtom(schedulesDataGridSelectedRowsAtom);
  const [
    checklistCreationProgressPercent,
    setChecklistCreationProgressPercentAtom,
  ] = useAtom(checklistCreationProgressPercentAtom);

  const setChecklistCreationState = (state: typeof checklistCreationState) => {
    setChecklistCreationStateAtom(state);
  };

  const setSchedulesDataGridSelectedRows = (
    selectedRows: typeof schedulesDataGridSelectedRows
  ) => {
    setSchedulesDataGridSelectedRowsAtom(selectedRows);
  };

  const setChecklistCreationProgressPercent = (
    percent: typeof checklistCreationProgressPercent
  ) => {
    setChecklistCreationProgressPercentAtom(percent);
  };

  return {
    checklistCreationState,
    setChecklistCreationState,
    schedulesDataGridSelectedRows,
    setSchedulesDataGridSelectedRows,
    checklistCreationProgressPercent,
    setChecklistCreationProgressPercent,
  };
};
